<template>
  <div class="intendedPatientEdit">
    <div class="header">
      <div class="header_left">
        <div class="header_left_title">意向患者信息表</div>
      </div>
      <div class="header_right">
        <div class="header_right_btn btn_cancel" @click="toBack">取消</div>
        <div class="header_right_btn btn_save" @click="save">保存</div>
      </div>
    </div>
    <div class="content">
      <el-form ref="form" class="content_form" :rules="rules" :model="form" label-width="130px">
        <div class="sector">
          <div class="sector_title">系统信息</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="渠道：" prop="channelCode">
                  <el-cascader class="form_input" v-model.trim="form.channelCode" :options="channelList" :props="{ label: 'channelName', value: 'channelVal', children: 'items', emitPath: false }" placeholder="请选择" :show-all-levels="false" :disabled="basicDisabled"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运营人员：" prop="operatorUserId">
                  <el-select class="form_input" v-model.trim="form.operatorUserId" filterable remote :remote-method="remoteOperatorUserList" placeholder="请选择" :disabled="basicDisabled">
                    <el-option v-for="item in operatorUserList" :key="item.userId" :label="item.nickName" :value="item.userId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="线索时间：" prop="inputDate">
                  <el-date-picker class="form_input" v-model.trim="form.inputDate" type="date" value-format="yyyy-MM-dd" :picker-options="inputDatePickerOptions" :editable="false" :clearable="false" placeholder="请选择" :disabled="basicDisabled"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="咨询人员：" prop="consultUserId">
                  <el-select class="form_input" v-model.trim="form.consultUserId" filterable remote :remote-method="remoteConsultUserList" placeholder="请选择" :disabled="basicDisabled">
                    <el-option v-for="item in consultUserList" :key="item.userId" :label="item.nickName" :value="item.userId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="备注：" prop="remark">
                  <el-input class="form_input" v-model.trim="form.remark" placeholder="请输入" :disabled="basicDisabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预约到馆时间：" prop="appointmentArrivalTime">
                  <el-date-picker class="form_input" v-model.trim="form.appointmentArrivalTime" type="date" value-format="yyyy-MM-dd" :editable="false" :clearable="false" placeholder="请选择" :disabled="basicDisabled"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="sector">
          <div class="sector_title">基础信息</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="微信号：" prop="patientWechat">
                  <el-input class="form_input" v-model.trim="form.patientWechat" maxlength="30" placeholder="请输入" :disabled="basicDisabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话：" prop="patientPhone">
                  <el-input class="form_input" v-model="form.patientPhone" maxlength="11" placeholder="请输入" @input="phoneInput" :disabled="basicDisabled"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="是否确认医生：" prop="isConfirmDoctor">
                  <el-select class="form_input" v-model.trim="form.isConfirmDoctor" placeholder="请选择" :disabled="basicDisabled">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="意向医生：" prop="intentDoctorId">
                  <el-select class="form_input" v-model.trim="form.intentDoctorId" filterable remote :remote-method="remoteIntentDoctorList" placeholder="请选择" :disabled="basicDisabled">
                    <el-option v-for="item in intentDoctorList" :key="item.doctorId" :label="item.nickName" :value="item.doctorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="推荐医生：" prop="recommendDoctorId">
                  <el-select class="form_input" v-model.trim="form.recommendDoctorId" filterable remote :remote-method="remoteRecommendDoctorList" placeholder="请选择" :disabled="basicDisabled">
                    <el-option v-for="item in recommendDoctorList" :key="item.doctorId" :label="item.nickName" :value="item.doctorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="16">
                <el-form-item label="咨询问题：" prop="question">
                  <el-input class="form_input" v-model.trim="form.question" type="textarea" :rows="3" resize="none" placeholder="请输入患者咨询问题" :disabled="basicDisabled"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="sector">
          <div class="sector_title">联系情况</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="是否添加微信：" prop="isAddWechat">
                  <el-select class="form_input" v-model.trim="form.isAddWechat" placeholder="请选择" :disabled="contactDisabled">
                    <el-option label="已加上" :value="2"></el-option>
                    <el-option label="未加上" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客资是否有效：" prop="isValid">
                  <el-select class="form_input" v-model.trim="form.isValid" placeholder="请选择" :disabled="contactDisabled">
                    <el-option label="有效" :value="2"></el-option>
                    <el-option label="无效" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="16">
                <el-form-item label="沟通情况：" prop="communication">
                  <el-input class="form_input" v-model.trim="form.communication" type="textarea" :rows="3" resize="none" placeholder="请输入联系过程中跟患者沟通的情况" :disabled="contactDisabled"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getChannelList, getSysUserList, getDoctorList, editIntent, getIntentDetail } from "@/api/operation"
  export default {
    name: 'intendedPatientEdit',
    data () {
      const validatePhone = (rule, value, callback) => {
        if (['', null, undefined].includes(value)) {
          callback()
        } else if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
      return {
        id: null,
        basicDisabled: false,
        contactDisabled: false,
        channelList: [],
        operatorUserList: [],
        inputDatePickerOptions: {
          disabledDate: (date) => {
            return date && date > new Date()
          }
        },
        consultUserList: [],
        intentDoctorList: [],
        recommendDoctorList: [],
        rules: {
          channelCode: [{ required: true, message: '请选择渠道', trigger: 'change' }],
          operatorUserId:  [{ required: true, message: '请选择运营人员', trigger: 'change' }],
          inputDate:  [{ required: true, message: '请选择日期', trigger: 'change' }],
          consultUserId:  [{ required: true, message: '请选择咨询人员', trigger: 'change' }],
          patientPhone: [{ validator: validatePhone, trigger: 'blur' }],
          isConfirmDoctor:  [{ required: true, message: '请选择是否确认医生', trigger: 'change' }]
        },
        form: {
          convertStat: '',
          channelCode: '',
          operatorUserId: '',
          inputDate: new Date().Format('yyyy-MM-dd'),
          consultUserId: '',
          remark: '',
          appointmentArrivalTime: '',
          patientWechat: '',
          patientPhone: '',
          isConfirmDoctor: '',
          intentDoctorId: '',
          recommendDoctorId: '',
          question: '',
          isAddWechat: '',
          isValid: '',
          communication: ''
        }
      }
    },
    methods: {
      phoneInput (value) {
        this.form.patientPhone = value.replace(/\D/g, '')
      },
      async getChannelList () {
        const res = await getChannelList()
        if (res.code == 200) {
          this.channelList = res.data
        }
      },
      async getDetail () {
        const res = await getIntentDetail({ id: this.id })
        if (res.code === 200) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = res.data[key]
            if (['isAddWechat', 'isValid'].includes(key) && this.form[key] === 0) {
              this.form[key] = ''
            }
          })
          if (!['', null, undefined].includes(res.data.operatorUserId)) {
            this.operatorUserList = [{ userId: res.data.operatorUserId, nickName: res.data.operatorUserName }]
          }
          if (!['', null, undefined].includes(res.data.consultUserId)) {
            this.consultUserList = [{ userId: res.data.consultUserId, nickName: res.data.consultUserName }]
          }
          if (!['', null, undefined].includes(res.data.intentDoctorId)) {
            this.intentDoctorList = [{ doctorId: res.data.intentDoctorId, nickName: res.data.doctorName }]
          }
          if (!['', null, undefined].includes(res.data.recommendDoctorId)) {
            this.recommendDoctorList = [{ doctorId: res.data.recommendDoctorId, nickName: res.data.recommendDoctorName }]
          }

          if (this.form.convertStat === 2) {
            this.basicDisabled = true
            if (!(['', null, undefined, 0].includes(this.form.isAddWechat) || ['', null, undefined, 0].includes(this.form.isValid))) {
              this.contactDisabled = true
            }
          }
        }
      },
      async remoteOperatorUserList (query) {
        const res = await getSysUserList({ searchKey: query })
        if (res.code == 200) {
          this.operatorUserList = res.data
        }
      },
      async remoteConsultUserList (query) {
        const res = await getSysUserList({ searchKey: query })
        if (res.code == 200) {
          this.consultUserList = res.data
        }
      },
      async remoteIntentDoctorList (query) {
        const res = await getDoctorList({ searchKey: query })
        if (res.code == 200) {
          this.intentDoctorList = res.data
        }
      },
      async remoteRecommendDoctorList (query) {
        const res = await getDoctorList({ searchKey: query })
        if (res.code == 200) {
          this.recommendDoctorList = res.data
        }
      },
      toBack () {
        this.$router.back()
      },
      save () {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            const emptyValues = [undefined, null, '']
            if (emptyValues.includes(this.form.patientWechat) && emptyValues.includes(this.form.patientPhone)) {
              this.$message.error('微信号与电话至少填写一项')
              return false
            }
            if (this.form.isConfirmDoctor == 1 && (emptyValues.includes(this.form.intentDoctorId) && emptyValues.includes(this.form.recommendDoctorId))) {
              this.$message.error('意向医生与推荐医生至少选择一项')
              return false
            }
            const res = await editIntent({ id: this.id, ...this.form })
            if (res.code === 200) {
              this.$message.success('保存成功')
              if (['', null, undefined].includes(this.id)) {
                window.sessionStorage.removeItem('intendPatientInfo')
              }
              this.$router.back()
            } else {
              this.$message.error(res.msg)
            }
          } else {
            return false;
          }
        })
      }
    },
    created () {
      this.getChannelList()
      if (this.$route.params.id) {
        this.id = this.$route.params.id
        this.getDetail()
      } else {
        const user = JSON.parse(window.sessionStorage.getItem('user'))
        this.consultUserList = [{ userId: user.userId, nickName: user.nickName  }]
        this.form.consultUserId = user.userId
      }
    }
  }
</script>

<style lang="less" scoped>
  .intendedPatientEdit {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    margin: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header {
    box-sizing: border-box;
    position: sticky;
    z-index: 2;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #E5E6EB;
  }

  .header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_left_title {
    font-weight: bold;
    font-size: 20px;
    color: #1D2129;
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header_right_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 32px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }

  .header_right_btn+.header_right_btn {
    margin: 0 0 0 8px;
  }

  .header_right_btn.btn_cancel {
    color: #4E5969;
    background-color: #F2F3F5;
  }

  .header_right_btn.btn_save {
    color: #FFFFFF;
    background-color: #1890FF;
  }

  .content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .content_form {
    width: 100%;
  }

  .sector {
    width: 100%;
  }

  .sector_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .sector_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0;
    width: 3px;
    height: 16px;
    background-color: #1890FF;
  }

  .sector_info {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .form_input {
    width: 100%;
  }
</style>
